// Listen for `DOMContentLoaded` event
document.addEventListener('DOMContentLoaded', (e) => {
  $("body").on("click", ".js-toggle-menu", function () {
    if ($(".js-toggle-menu").hasClass("is-active")) {
      $(".js-toggle-menu").removeClass("is-active");
      $("body").removeClass("menu-open");
      $(".overlay-menu").removeClass("open");
    } else {
      $(".overlay-menu").addClass("open");
      setTimeout(function() {
        $("body").addClass("menu-open");
        $(".js-toggle-menu").addClass("is-active");
      }, 150);
    }
  });
});



// Hide Filter Toggle close to Footer
$( document ).ready(function() {
  if($(window).scrollTop() + $(window).height() > $(document).height() - 500) {
    $("body").addClass("end-down");
  } else {
    $("body").removeClass("end-down");
  }
});

$(window).scroll(function() {
  if($(window).scrollTop() + $(window).height() > $(document).height() - 500) {
    $("body").addClass("end-down");
  } else {
    $("body").removeClass("end-down");
  }
});


$('a[href^="#"]').on('click', function (e) {
  const target = $(this.getAttribute('href'));

  if (target.length) {
    e.preventDefault();

    const offset = 150;

    $('html, body').stop().animate(
      {
        scrollTop: target.offset().top - offset
      },
      800
    );
  }
});
